import { functions } from '../firebase/firebase';

const queryLegacyMember = async ({ personalId }) => {
  if (!personalId) { return null; }
  let legacyMember = null;
  try {
    const legacyMemberResult = await functions.httpsCallable('getLegacyMember')({
      socialSecurityNumber: personalId,
    });

    if (typeof legacyMemberResult.data !== 'undefined'
      && legacyMemberResult.data !== null) {
      if (typeof legacyMemberResult.data.memberId === 'string') {
        legacyMemberResult.data.memberId = parseInt(legacyMemberResult.data.memberId);
      }

      if (legacyMemberResult.data.memberCategory !== null) {
        if (typeof legacyMemberResult.data.memberCategory === 'string') {
          legacyMemberResult.data.memberCategory = [legacyMemberResult.data.memberCategory];
        }
        // setMemberCategory(legacyMemberResult.data.memberCategory);
      }
      if (legacyMemberResult.data.district !== null) {
        // setDistrict(legacyMemberResult.data.district);
      }
    }
  } catch (error) {
    console.error(error);
    // setLegacyMember(null);
  }
};

export default queryLegacyMember;

